export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14896.a7495e00.jpg";